function fullURL(path) {
  return `${process.env.VUE_APP_API_ROOT}/${path}`;
};

export default {
  login(context, user) {

    return new Promise((resolve, reject) => {

      this._vm.$fetch(fullURL("users/login"), "POST", user)
      .then(response => {

        if (response.ok) return response.json();
        reject(response.status);

      })
      .then(data => {

        resolve(data);

      })
      .catch(error => {

        reject(error);

      });

    });

  },

  register(context, user) {

    return new Promise((resolve, reject) => {

      this._vm.$fetch(fullURL("users/sign-up"), "POST", user)
      .then(response => {
        if (response.ok) return response.json();
        reject(response.status);
      })
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });

    });

  },

  facebookLogin(context, user) {

    return new Promise((resolve, reject) => {

      this._vm.$fetch(fullURL("users/facebookLogin"), "POST", user)
      .then(response => {

        if (response.ok) return response.json();
        reject(response.status);

      })
      .then(data => {

        resolve(data);

      })
      .catch(error => {

        reject(error);

      });

    });

  },

  getLegislations(context) {

    return new Promise((resolve, reject) => {

      this._vm.$fetch(fullURL("legislations"), "GET")
      .then(response => {

        if (response.ok) return response.json();
        
        reject(response.status);

      })
      .then(data => {

        resolve(data);

      })
      .catch(error => {

        reject(error);

      });

    });

  },

  getLegislation(context, id) {

    return new Promise((resolve, reject) => {

      let filter = {
        where: {
          id: id
        },
        include: [
          {
            relation: "consultations",
            scope: {
              where: {
                userAccountId: context.state.user.user.id
              }
            }
          },
          {
            relation: "sections"
          }
        ]
      };

      this._vm.$fetch(fullURL(`legislations?filter=${JSON.stringify(filter)}`), "GET")
      .then(response => {

        if (response.ok) return response.json();

        reject(response.status);

      })
      .then(data => {

        resolve(data[0]);

      })
      .catch(error => {

        reject(error);

      });

    })

  },

  getClauses(context, section) {

    return new Promise((resolve, reject) => {

      let filter = {
        where: {
          sectionId: section
        },
        include: [
          {
            relation: "subClauses",
          },
          {
            relation: "questions",
            scope: {
              include: "answers",
              scope: {
                where: {
                  userAccountId: context.state.user.user.id
                }
              }
            }
          }
        ]
      };

      this._vm.$fetch(fullURL(`clauses?filter=${JSON.stringify(filter)}`))
      .then(response => {

        if (response.ok) return response.json();
        reject(response.status);

      })
      .then(data => {

        data.forEach(c => {

          c.questions.forEach(q => {

            q.answers = q.answers.filter(a => a.userAccountId === context.state.user.user.id);

          });

        });

        resolve(data);

      })
      .catch(error => {

        reject(error);

      });

    });

  },

  getMeta(context, vision) {

    return new Promise((resolve, reject) => {

      this._vm.$fetch(fullURL("metadata") + `?filter={"where": {"clauseId": "${vision}"}}`, "GET")
      .then(response => {

        if (response.ok) return response.json();
        reject(response.status);

      })
      .then(data => {

        resolve(data[0]);

      })
      .catch(error => {

        reject(error);

      });

    });

  },

  answer(context, answer) {

    return new Promise((resolve, reject) => {

      this._vm.$fetch(fullURL(`answers/upsertWithWhere?where={"id": "${answer.id}"}`), "POST", answer)
      .then(response => {

        if (response.ok) return response.json();
        reject(response.status);

      })
      .then(data => {

        resolve(data);

      })
      .catch(error => {

        reject(error);

      });

    })

  },

  updateConsultation(context, consultation) {

    return new Promise((resolve, reject) => {

      this._vm.$fetch(fullURL(`consultations/upsertWithWhere?where={"legislationId": "${consultation.legislationId}", "userAccountId": "${consultation.userAccountId}"}`), "POST", consultation)
      .then(response => {

        if(response.ok) return response.json();
        reject(response.status);

      })
      .then(data => {

        resolve(data);

      })
      .catch(error => {

        reject(error);

      });

    });

  },

  changePassword(context, password) {

    return new Promise((resolve, reject) => {

      this._vm.$fetch(fullURL("users/changePassword"), "POST", password)
      .then(response => {

        if (response.ok) return resolve();
        reject(response.status);

      })
      .then(data => {

        resolve(data);

      })
      .catch(error => {
        reject(error);
      });

    });

  }

};